(function () {
  if (!window.IntersectionObserver) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.removeAttribute('reveal-on-scroll');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '-100px 0px 0px 0px' }
  );

  document.querySelectorAll('[reveal-on-scroll="true"]').forEach(function (el) {
    observer.observe(el);
  });
})();
